// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main__mTCX_","transOpacity":"index_transOpacity__xcy1C"};